var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Inject, Watch } from 'vue-property-decorator';
import { BSpinner } from 'bootstrap-vue';
var MainStage = /** @class */ (function (_super) {
    __extends(MainStage, _super);
    function MainStage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.searchRoutes = ['section-5', 'section-6', 'section-7', 'section-8', 'section-9', 'section-10', 'section-11'];
        _this.headDummyPath = '/storage/placeholder/';
        _this.headDummies = [
            'header_01.png',
            'header_02.png',
            'header_03.png',
            'header_04.png',
            'header_05.png',
        ];
        return _this;
    }
    Object.defineProperty(MainStage.prototype, "groupIdFromRoute", {
        get: function () {
            return parseInt(this.$route.params.groupId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStage.prototype, "groups", {
        get: function () {
            var _a;
            return (_a = this.session.user) === null || _a === void 0 ? void 0 : _a.groups;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStage.prototype, "groupFromSession", {
        get: function () {
            var _this = this;
            if (this.groups) {
                return this.groups.find(function (group) { return Number(group.id) === _this.groupIdFromRoute; });
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStage.prototype, "platformFromSession", {
        get: function () {
            var _a;
            return (_a = this.session.user) === null || _a === void 0 ? void 0 : _a.neighbourhood;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStage.prototype, "communityFromRoute", {
        get: function () {
            var _a;
            return ((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.sideNav) === 'section-3';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStage.prototype, "communityFromSession", {
        get: function () {
            var _a;
            return (_a = this.session.user) === null || _a === void 0 ? void 0 : _a.community;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStage.prototype, "customMainStage", {
        get: function () {
            var _a;
            return '/img/page-header/' + ((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.customMainStage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MainStage.prototype, "backgroundImage", {
        get: function () {
            var _a, _b, _c, _d, _e, _f;
            var dummyHeader = this.headDummyPath + this.headDummies.sort(function () { return .5 - Math.random(); })[0];
            if ((_a = this.$route.meta) === null || _a === void 0 ? void 0 : _a.customMainStage) {
                return this.customMainStage;
            }
            if (this.searchRoutes.includes((_b = this.$route.meta) === null || _b === void 0 ? void 0 : _b.sideNav) && this.$store.state.globalSearch.globalSearchHeader) {
                return this.$store.state.globalSearch.globalSearchHeader;
            }
            if (this.groupFromSession) {
                return (_c = this.groupFromSession.profile_image_path) !== null && _c !== void 0 ? _c : dummyHeader;
            }
            if (this.communityFromRoute) {
                return (_e = (_d = this.communityFromSession) === null || _d === void 0 ? void 0 : _d.profile_image_path) !== null && _e !== void 0 ? _e : dummyHeader;
            }
            if (this.platformFromSession) {
                return (_f = this.platformFromSession.profile_image_path) !== null && _f !== void 0 ? _f : dummyHeader;
            }
            return dummyHeader;
        },
        enumerable: false,
        configurable: true
    });
    MainStage.prototype.onSessionUserUpdate = function () {
        this.loading = false;
    };
    MainStage.prototype.mounted = function () {
        this.onSessionUserUpdate();
        this.$root.$on('groupProfileImageChanged', this.onGroupProfileImageChanged);
        this.$root.$on('platformProfileImageChanged', this.onPlatformProfileImageChanged);
    };
    MainStage.prototype.onGroupProfileImageChanged = function (path) {
        this.groupFromSession.profile_image_path = path;
    };
    MainStage.prototype.onPlatformProfileImageChanged = function (path) {
        this.platformFromSession.profile_image_path = path;
    };
    __decorate([
        Inject(),
        __metadata("design:type", Object)
    ], MainStage.prototype, "session", void 0);
    __decorate([
        Watch('$store.state.session.user.status'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MainStage.prototype, "onSessionUserUpdate", null);
    MainStage = __decorate([
        Component({
            components: {
                BSpinner: BSpinner,
            },
        })
    ], MainStage);
    return MainStage;
}(Vue));
export default MainStage;
